/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { theme } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { isNotEmpty, useQueryState } from "~/tools";
import { ExpandableTag } from "../ExpandableTag/ExpandableTag";
import { ButtonWrap } from "../Utils/ButtonWrap";

type Filter = [string, string | string[] | boolean];

type Props = {
  filters: Filter[];
  onRemoveKey?: (fields: (string | number | symbol)[]) => void;
};

export function ActiveFilters({ filters, onRemoveKey }: Props) {
  const showClearTrigger = isNotEmpty(filters);
  const [, set] = useQueryState();

  return (
    <FlexContainer
      wrap="wrap"
      css={{ margin: `-${theme.spacing.spacing02} 0` }}
    >
      <span css={{ marginRight: theme.spacing.spacing02 }}>
        Applied filters:
      </span>
      {filters.map(([key, value]) => {
        return (
          <ExpandableTag
            key={key}
            name={key}
            value={value}
            onRemoveKey={() => {
              onRemoveKey && onRemoveKey([key]);
            }}
          />
        );
      })}

      {showClearTrigger && (
        <ButtonWrap
          css={{
            color: theme.color.interactive.link,
            margin: theme.spacing.spacing02,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "&:hover": {
              cursor: "pointer",
              textDecoration: "underline",
            },
          }}
          onClick={() => set("filters")({})}
        >
          Clear Filters & Reload
        </ButtonWrap>
      )}
    </FlexContainer>
  );
}
